module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "app__main",
    attrs: {
      "id": "app"
    }
  }, [(_vm.globals.spinnerVisible) ? _c('div', {
    staticClass: "loading"
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "navbar",
    class: {
      db_layout: _vm.feature.isDBTarget
    },
    attrs: {
      "id": "app-navbar"
    }
  }, [_c('div', {
    staticClass: "container-fluid",
    staticStyle: {
      "padding-left": "0px"
    }
  }, [_c('ul', {
    staticClass: "nav navbar-nav"
  }, [_c('li', {
    class: {
      active: !_vm.$route.name
    }
  }, [_c('a', {
    staticStyle: {
      "padding": "10px"
    }
  }, [(_vm.feature.isAudiTarget) ? _c('img', {
    attrs: {
      "src": "/static/audi_loop_logo.png",
      "height": "40"
    }
  }) : (_vm.feature.isDBTarget) ? _c('img', {
    staticStyle: {
      "margin-top": "5px"
    },
    attrs: {
      "src": "/static/DB_loop_service_store_logo.png",
      "height": "25"
    }
  }) : (_vm.feature.isPorscheTarget) ? _c('img', {
    staticStyle: {
      "margin-top": "5px"
    },
    attrs: {
      "src": "/static/Porsche_loop_logo.png",
      "height": "35"
    }
  }) : _c('img', {
    attrs: {
      "src": "/static/msm_loop_logo.png",
      "height": "40"
    }
  })])])]), _vm._v(" "), _c('ul', {
    staticClass: "nav navbar-nav"
  }, [(_vm.globals.operationPermitted('Entities.Client.AllowRead')) ? _c('li', {
    class: {
      active: _vm.$route.name === 'ClientManagement'
    }
  }, [_c('router-link', {
    attrs: {
      "to": "/clientmanagement"
    }
  }, [_vm._v(_vm._s(_vm.lang.A0000))])], 1) : _vm._e(), _vm._v(" "), (_vm.globals.operationPermitted('Entities.Location.AllowRead')) ? _c('li', {
    class: {
      active: _vm.$route.name === 'LocationManagement'
    }
  }, [_c('router-link', {
    attrs: {
      "to": "/locationmanagement"
    }
  }, [_vm._v(_vm._s(_vm.lang.A0001))])], 1) : _vm._e(), _vm._v(" "), (_vm.globals.operationPermitted('Entities.User.AllowRead')) ? _c('li', {
    class: {
      active: _vm.$route.name === 'UserManagement'
    }
  }, [_c('router-link', {
    attrs: {
      "to": "/usermanagement"
    }
  }, [_vm._v(_vm._s(_vm.lang.A0010))])], 1) : _vm._e(), _vm._v(" "), (_vm.globals.operationPermitted('Entities.Project.AllowRead')) ? _c('li', {
    class: {
      active: _vm.$route.name === 'ProjectManagement'
    }
  }, [_c('router-link', {
    attrs: {
      "to": "/projectmanagement"
    }
  }, [_vm._v(_vm._s(_vm.lang.A0011))])], 1) : _vm._e(), _vm._v(" "), (_vm.globals.operationPermitted('Entities.Agency.AllowRead')) ? _c('li', {
    class: {
      active: _vm.$route.name === 'AgencyManagement'
    }
  }, [_c('router-link', {
    attrs: {
      "to": "/agencymanagement"
    }
  }, [_vm._v(_vm._s(_vm.lang.A0012))])], 1) : _vm._e(), _vm._v(" "), (_vm.globals.operationPermitted('Entities.Survey.AllowRead')) ? _c('li', {
    class: {
      active: _vm.$route.name === 'SurveyManagement'
    }
  }, [_c('router-link', {
    attrs: {
      "to": "/surveymanagement"
    }
  }, [_vm._v(_vm._s(_vm.lang.A0013))])], 1) : _vm._e(), _vm._v(" "), (
    _vm.globals.operationPermitted('Entities.SurveyInstance.AllowRead')
  ) ? _c('li', {
    class: {
      active: _vm.$route.name === 'CheckManagement'
    }
  }, [_c('router-link', {
    attrs: {
      "to": "/checkmanagement"
    }
  }, [_vm._v(_vm._s(_vm.lang.A0014))])], 1) : _vm._e(), _vm._v(" "), (_vm.globals.operationPermitted('Entities.KPI.AllowRead')) ? _c('li', {
    class: {
      active: _vm.$route.name === 'KPIManagement'
    }
  }, [_c('router-link', {
    attrs: {
      "to": "/kpimanagement"
    }
  }, [_vm._v(_vm._s(_vm.lang.A0016))])], 1) : _vm._e(), _vm._v(" "), (_vm.globals.operationPermitted('Entities.Shopper.AllowRead')) ? _c('li', {
    class: {
      active: _vm.$route.name === 'ShopperManagement'
    }
  }, [_c('router-link', {
    attrs: {
      "to": "/shoppermanagement"
    }
  }, [_vm._v(_vm._s(_vm.lang.A0023))])], 1) : _vm._e(), _vm._v(" "), (_vm.globals.operationPermitted('Entities.Recruiting.AllowRead')) ? _c('li', {
    class: {
      active: _vm.$route.name === 'Recruiting'
    }
  }, [_c('router-link', {
    attrs: {
      "to": "/recruiting"
    }
  }, [_vm._v(_vm._s(_vm.lang.A0029))])], 1) : _vm._e(), _vm._v(" "), (
    _vm.feature.isEnabled('shopperApproval') && _vm.globals.currentUserInfo
  ) ? _c('li', {
    class: {
      active: _vm.$route.name === 'ShopperApproval'
    }
  }, [_c('router-link', {
    attrs: {
      "to": "/shopperapproval"
    }
  }, [_vm._v(_vm._s(_vm.lang.A0032))])], 1) : _vm._e()]), _vm._v(" "), (_vm.userLoginState) ? _c('ul', {
    staticClass: "nav navbar-nav navbar-right"
  }, [_c('li', [_c('a', {
    staticStyle: {
      "max-height": "60px"
    },
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.openSelectLanguageDialog()
      }
    }
  }, [_c('i', {
    staticClass: "material-icons md-24"
  }, [_vm._v("public")]), _vm._v("\n            " + _vm._s(_vm.languageList[_vm.globals.selectedLanguage]) + "\n          ")])]), _vm._v(" "), _c('li', {
    staticClass: "dropdown"
  }, [_c('a', {
    staticClass: "dropdown-toggle",
    staticStyle: {
      "max-height": "60px"
    },
    attrs: {
      "href": "bootstrap-elements.html",
      "data-toggle": "dropdown"
    }
  }, [_c('i', {
    staticClass: "material-icons md-24"
  }, [_vm._v("person")]), _vm._v("\n            " + _vm._s(_vm.globals.currentUserInfo.LoginName) + "\n            "), _c('b', {
    staticClass: "caret"
  })]), _vm._v(" "), _c('ul', {
    staticClass: "dropdown-menu"
  }, [(_vm.feature.isEnabled('userSettings')) ? _c('li', [_c('router-link', {
    attrs: {
      "to": "/settings"
    }
  }, [_c('i', {
    staticClass: "material-icons md-24"
  }, [_vm._v("settings")]), _vm._v("\n                " + _vm._s(_vm.lang.A0024) + "\n              ")])], 1) : _vm._e(), _vm._v(" "), (_vm.feature.isEnabled('clearData')) ? _c('li', [_c('a', {
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.openClearDataDialog()
      }
    }
  }, [_c('i', {
    staticClass: "material-icons md-24"
  }, [_vm._v("delete_forever")]), _vm._v("\n                " + _vm._s(_vm.lang.A0034) + "\n              ")])]) : _vm._e(), _vm._v(" "), (!_vm.feature.isAudiTarget) ? _c('li', [_c('a', {
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.redirectToSupport()
      }
    }
  }, [_c('i', {
    staticClass: "material-icons md-24"
  }, [_vm._v("live_help")]), _vm._v("\n                " + _vm._s(_vm.lang.A0021) + "\n              ")])]) : _vm._e(), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.userLogout()
      }
    }
  }, [_c('i', {
    staticClass: "material-icons md-24"
  }, [_vm._v("exit_to_app")]), _vm._v("\n                " + _vm._s(_vm.lang.A0003) + "\n              ")])])])])]) : _vm._e()])]), _vm._v(" "), (_vm.maintenance) ? _c('div', {
    staticClass: "maintenance"
  }, [_c('h3', {
    staticClass: "maintenance-headline",
    on: {
      "click": function($event) {
        _vm.showMaintenance = !_vm.showMaintenance
      }
    }
  }, [(_vm.globals.selectedLanguage == 'de') ? [_vm._v("\n        Demnächst Wartungsarbeiten!\n      ")] : [_vm._v(" Maintenance soon! ")], _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.showMaintenance),
      expression: "!showMaintenance"
    }],
    staticClass: "material-icons"
  }, [_vm._v("\n        expand_more ")]), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showMaintenance),
      expression: "showMaintenance"
    }],
    staticClass: "material-icons"
  }, [_vm._v("\n        expand_less\n      ")])], 2), _vm._v(" "), _c('article', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showMaintenance),
      expression: "showMaintenance"
    }],
    staticClass: "maintenance-article"
  }, [(_vm.globals.selectedLanguage == 'de') ? _c('span', [_vm._v("Sehr geehrte/r Nutzer/in "), _c('br'), _c('br'), _vm._v("\n        die Loop Plattform wird am 20.01.2022 aufgrund von Wartungsarbeiten\n        zwischen 17:00 und 21:00 Uhr für 120 Minuten nicht erreichbar sein."), _c('br'), _vm._v(" "), _c('b', [_vm._v("Wartungsfenster:")]), _vm._v(" Am 20.01.2022 von 17 Uhr bis 21 Uhr\n        (GMT+1)."), _c('br'), _c('br'), _vm._v(" "), _c('b', [_vm._v("Ausfalldauer:")]), _vm._v(" 120 Minuten."), _c('br'), _c('br'), _vm._v(" "), _c('b', [_vm._v("Hinweis:")]), _vm._v(" Entsprechende Hinweise werden auf den Webseiten\n        platziert. Nach Abschluss der Arbeiten versenden wir eine\n        Statusmeldung. "), _c('br'), _c('br'), _vm._v(" "), _c('b', [_vm._v("Grund:")]), _vm._v(" Der Betreiber des Rechenzentrums führt technische\n        Umbaumaßnahmen durch, die eine Teilabschaltung der Datenleitungen\n        erfordern.\n      ")]) : _c('span', [_vm._v("Dear user,"), _c('br'), _c('br'), _vm._v("\n        the Loop platform will be unavailable for 120 minutes between 17:00\n        and 21:00 on 20.01.2022 due to maintenance work."), _c('br'), _vm._v(" "), _c('b', [_vm._v("Maintenance work:")]), _vm._v(" January 20, 2022 from 5pm until 9pm\n        (GMT+1)."), _c('br'), _c('br'), _vm._v(" "), _c('b', [_vm._v("Loss of connectivity:")]), _vm._v(" 120 minutes."), _c('br'), _c('br'), _vm._v(" "), _c('b', [_vm._v("Notifications:")]), _vm._v(" Appropriate notice will be placed on the\n        website. A status mail will be sent after completion of\n        maintenance."), _c('br'), _c('br'), _vm._v(" "), _c('b', [_vm._v("Reason:")]), _vm._v(" The data centre operations team implements technical\n        modifications that require a partial connectivity loss.")]), _vm._v(" "), _c('br')])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "app__router-view"
  }, [(_vm.isAccessTokenAvailable) ? _c('router-view', {
    key: _vm.$route.fullPath
  }) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "modal fade",
    attrs: {
      "id": "selectLanguageDialog",
      "data-backdrop": "static",
      "data-keyboard": "false"
    }
  }, [_c('div', {
    staticClass: "modal-dialog"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-hidden": "true"
    }
  }, [_vm._v("\n            ×\n          ")]), _vm._v(" "), _c('h4', {
    staticClass: "modal-title"
  }, [_c('b', [_vm._v(_vm._s(_vm.lang.A0006))])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('p', [_c('b', [_vm._v(_vm._s(_vm.lang.A0007))])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8 col-md-offset-2",
    staticStyle: {
      "padding-bottom": "20px"
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.nextLanguage),
      expression: "nextLanguage"
    }],
    staticClass: "form-control language-select",
    attrs: {
      "id": "selectLanguage"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.nextLanguage = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.languageList), function(language, isocode) {
    return _c('option', {
      key: isocode,
      domProps: {
        "value": isocode
      }
    }, [_vm._v("\n                  " + _vm._s(language) + "\n                ")])
  }), 0)])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    staticClass: "btn btn-raised btn-default dialog-btn-primary",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    },
    on: {
      "click": _vm.selectedLanguageDialogClosed
    }
  }, [_vm._v("\n            " + _vm._s(_vm.lang.A0009) + "\n          ")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal fade",
    attrs: {
      "id": "selectClearData",
      "data-backdrop": "static",
      "data-keyboard": "false"
    }
  }, [_c('div', {
    staticClass: "modal-dialog"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-hidden": "true"
    }
  }, [_vm._v("\n            ×\n          ")]), _vm._v(" "), _c('h4', {
    staticClass: "modal-title"
  }, [_c('b', [_vm._v(_vm._s(_vm.lang.A0034))])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticClass: "form-group",
    staticStyle: {
      "text-align": "right",
      "overflow": "hidden"
    }
  }, [_c('label', {
    staticClass: "col-md-4 control-label",
    attrs: {
      "for": "clearDataCache",
      "title": _vm.lang.A0035
    }
  }, [_vm._v(_vm._s(_vm.lang.A0035) + ":")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8"
  }, [_c('div', {
    staticClass: "checkbox",
    staticStyle: {
      "float": "left"
    }
  }, [_c('label', {
    attrs: {
      "title": _vm.lang.A0035
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.clearDataSelection.Cache),
      expression: "clearDataSelection.Cache"
    }],
    attrs: {
      "data-toggle": "tooltip",
      "type": "checkbox",
      "id": "clearDataCache"
    },
    domProps: {
      "checked": Array.isArray(_vm.clearDataSelection.Cache) ? _vm._i(_vm.clearDataSelection.Cache, null) > -1 : (_vm.clearDataSelection.Cache)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.clearDataSelection.Cache,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.clearDataSelection, "Cache", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.clearDataSelection, "Cache", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.clearDataSelection, "Cache", $$c)
        }
      }
    }
  }), _vm._v(" "), _vm._m(0)])])]), _vm._v(" "), _c('label', {
    staticClass: "col-md-4 control-label",
    attrs: {
      "for": "clearDataCookies",
      "title": _vm.lang.A0036
    }
  }, [_vm._v(_vm._s(_vm.lang.A0036) + ":")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8"
  }, [_c('div', {
    staticClass: "checkbox",
    staticStyle: {
      "float": "left"
    }
  }, [_c('label', {
    attrs: {
      "title": _vm.lang.A0036
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.clearDataSelection.Cookies),
      expression: "clearDataSelection.Cookies"
    }],
    attrs: {
      "data-toggle": "tooltip",
      "type": "checkbox",
      "id": "clearDataCookies"
    },
    domProps: {
      "checked": Array.isArray(_vm.clearDataSelection.Cookies) ? _vm._i(_vm.clearDataSelection.Cookies, null) > -1 : (_vm.clearDataSelection.Cookies)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.clearDataSelection.Cookies,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.clearDataSelection, "Cookies", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.clearDataSelection, "Cookies", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.clearDataSelection, "Cookies", $$c)
        }
      }
    }
  }), _vm._v(" "), _vm._m(1)])])]), _vm._v(" "), _c('label', {
    staticClass: "col-md-4 control-label",
    attrs: {
      "for": "clearDataStorage",
      "title": _vm.lang.A0037
    }
  }, [_vm._v(_vm._s(_vm.lang.A0037) + ":")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8"
  }, [_c('div', {
    staticClass: "checkbox",
    staticStyle: {
      "float": "left"
    }
  }, [_c('label', {
    attrs: {
      "title": _vm.lang.A0037
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.clearDataSelection.Storage),
      expression: "clearDataSelection.Storage"
    }],
    attrs: {
      "data-toggle": "tooltip",
      "type": "checkbox",
      "id": "clearDataStorage"
    },
    domProps: {
      "checked": Array.isArray(_vm.clearDataSelection.Storage) ? _vm._i(_vm.clearDataSelection.Storage, null) > -1 : (_vm.clearDataSelection.Storage)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.clearDataSelection.Storage,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.clearDataSelection, "Storage", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.clearDataSelection, "Storage", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.clearDataSelection, "Storage", $$c)
        }
      }
    }
  }), _vm._v(" "), _vm._m(2)])])]), _vm._v(" "), _c('label', {
    staticClass: "col-md-4 control-label",
    attrs: {
      "for": "clearDataExecutionContexts",
      "title": _vm.lang.A0038
    }
  }, [_vm._v(_vm._s(_vm.lang.A0038) + ":")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8"
  }, [_c('div', {
    staticClass: "checkbox",
    staticStyle: {
      "float": "left"
    }
  }, [_c('label', {
    attrs: {
      "title": _vm.lang.A0038
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.clearDataSelection.ExecutionContexts),
      expression: "clearDataSelection.ExecutionContexts"
    }],
    attrs: {
      "data-toggle": "tooltip",
      "type": "checkbox",
      "id": "clearDataExecutionContexts"
    },
    domProps: {
      "checked": Array.isArray(_vm.clearDataSelection.ExecutionContexts) ? _vm._i(_vm.clearDataSelection.ExecutionContexts, null) > -1 : (_vm.clearDataSelection.ExecutionContexts)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.clearDataSelection.ExecutionContexts,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.clearDataSelection, "ExecutionContexts", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.clearDataSelection, "ExecutionContexts", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.clearDataSelection, "ExecutionContexts", $$c)
        }
      }
    }
  }), _vm._v(" "), _vm._m(3)])])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    staticClass: "btn btn-raised btn-default dialog-btn-primary",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    },
    on: {
      "click": _vm.selecteClearDataDialogClosed
    }
  }, [_vm._v("\n            " + _vm._s(_vm.lang.A0009) + "\n          ")])])])])]), _vm._v(" "), _c('confirmation-dialog', {
    attrs: {
      "dialogId": _vm.confirmationDialogId,
      "confirmationTitle": _vm.confirmationDialogData.confirmationTitle,
      "yesButtonText": _vm.confirmationDialogData.yesButtonText,
      "noButtonText": _vm.confirmationDialogData.noButtonText,
      "showDialog": _vm.showConfirmationDialog,
      "colorRed": _vm.confirmationDialogData.colorRed,
      "htmlText": _vm.confirmationDialogData.htmlText
    },
    on: {
      "onYesConfirmation": _vm.onYesConfirmation,
      "onNoConfirmation": _vm.onNoConfirmation,
      "dialogClosed": _vm.onConfirmationDialogClosed,
      "closeDialog": _vm.onCloseConfirmationDialog
    }
  }), _vm._v(" "), _c('notification-dialog', {
    attrs: {
      "dialogId": _vm.notificationDialogId,
      "notificationTitle": _vm.notificationDialogData.notificationTitle,
      "closeButtonText": _vm.notificationDialogData.closeButtonText,
      "showDialog": _vm.showNotificationDialog,
      "colorRed": _vm.notificationDialogData.colorRed,
      "htmlText": _vm.notificationDialogData.htmlText
    },
    on: {
      "closeDialog": _vm.onCloseNotificationDialog,
      "dialogClosed": _vm.onNotificationDialogClosed
    }
  }), _vm._v(" "), _c('UploadProgressModal'), _vm._v(" "), (_vm.globals.currentUserRole < 2) ? _c('edit-vat-rates-modal', {
    attrs: {
      "showModal": _vm.showEditVatRatesModal
    },
    on: {
      "modalClosed": function($event) {
        _vm.showEditVatRatesModal = false
      }
    }
  }) : _vm._e(), _vm._v(" "), _c('changelog-modal', {
    attrs: {
      "showDialog": _vm.showChangelogModal
    },
    on: {
      "closeDialog": function($event) {
        _vm.showChangelogModal = false
      }
    }
  }), _vm._v(" "), _c('HtmlEditorModal', {
    attrs: {
      "showModal": _vm.showHtmlEditorModal
    },
    on: {
      "modalClosed": function($event) {
        _vm.showHtmlEditorModal = false
      }
    }
  }), _vm._v(" "), _c('ElementHistoryModal'), _vm._v(" "), (_vm.globals.operationPermitted('Entities.Feed.AllowRead')) ? _c('FeedModal') : _vm._e(), _vm._v(" "), _c('div', {
    class: {
      warning: _vm.globals.isLoggedInAsOtherUser
    },
    attrs: {
      "id": "defaultAppFooter"
    }
  }, [(_vm.globals.isLoggedInAsOtherUser) ? _c('span', [_vm._v("\n      " + _vm._s(_vm.lang.A0033) + ":\n      "), _c('router-link', {
    attrs: {
      "to": "/settings"
    }
  }, [_c('b', [_vm._v(_vm._s(_vm.globals.currentUserInfo.IsLoggedInAsUser))])])], 1) : _vm._e(), _vm._v(" "), _c('span', {
    attrs: {
      "id": "footerLinkContainer"
    }
  }, [_c('a', {
    attrs: {
      "href": ("https://" + _vm.mainOpHost + "/imprint.html"),
      "target": "_blank"
    }
  }, [_vm._v(_vm._s(_vm.lang.A0018))]), _vm._v(" "), _c('a', {
    attrs: {
      "href": ("https://" + _vm.mainOpHost + "/dataProtection.html"),
      "target": "_blank"
    }
  }, [_vm._v(_vm._s(_vm.lang.A0017))])]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "frontendVersionIndicator"
    },
    on: {
      "click": function($event) {
        _vm.showChangelogModal = true
      }
    }
  }, [_vm._v("v" + _vm._s(_vm.appVersion))])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "checkbox-material"
  }, [_c('span', {
    staticClass: "check"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "checkbox-material"
  }, [_c('span', {
    staticClass: "check"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "checkbox-material"
  }, [_c('span', {
    staticClass: "check"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "checkbox-material"
  }, [_c('span', {
    staticClass: "check"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-bd26cd6c","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 1799
// module chunks = 2